module.exports = __webpack_public_path__ + "static/media/insurePlanFooter.e52575b7.svg";